/**
 * Normaliza nombre comercial de empresa (onboarding create paths).
 */
export function normalizeCommercialName(raw) {
  const EMPTY_MSG = 'Ingresá el nombre de tu empresa para continuar.';
  if (raw == null) return { ok: false, error: EMPTY_MSG };
  const value = String(raw).trim().replace(/\s+/g, ' ');
  if (!value || value.length < 2 || value.length > 80) return { ok: false, error: EMPTY_MSG };
  return { ok: true, value };
}

export default normalizeCommercialName;
